import { ContentArticle } from '../types';
import banner from '../assets/twitchcon-san-diego.jpg';
import { Author } from '../authors/trey';

const body = (<div dangerouslySetInnerHTML={{ __html: `<p>We’ll be showing off Playcast at TwitchCon 2024 in San Diego from September 20 to 22! Make sure to stop by our booth (#1714-SW) in the Streamer Workshop section of the show floor to try out version 1.0 of Playcast, play some of your favorite games, and earn exclusive prizes!</p>
<p>For more details about the show and our booth, follow our Twitter for live updates.</p>
<p>See you in San Diego!</p>
` }} className="article" />);

export const TwitchSanDiego: ContentArticle = {
  title: `Playcast @ TwitchCon San Diego`,
  slug: `twitchcon-san-diego`,
  published: `2024-09-18`,
  author: Author,
  banner: banner,
  summary: `We’ll be showing off Playcast at TwitchCon 2024 in San Diego from September 20 to 22!`,
  body: body,
};
